import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import spinnerLight from '../../../assets/loaders/indeterminate-spinner-small-light.svg';
import spinnerDark from '../../../assets/loaders/indeterminate-spinner-small-dark.svg';
const LoadingIndicator = props => {
  const {
    t
  } = useTranslation();
  const {
    variant = 'light',
    alt = t('loading'),
    className
  } = props;
  const src = variant === 'light' ? spinnerLight : spinnerDark;
  const classNames = c('LoadingIndicator', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }));
};
export default LoadingIndicator;